export default __webpack_public_path__ + "static/media/carlotta-sedlatschek-until-20250304.3ee505e2.jpg";